
require("./../../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import GroupInvitation from 'features/group-invitation/';
import GuestInvitation from 'features/group-invitation/GuestInvitation';
import authCookie from 'utils/authCookie';
import sanitizer from 'string-sanitizer';
import chatApi from 'lib/api/chat';
import { GROUP_SHARED_LINK_INVITATION } from 'features/chat/constant';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { IS_LOGGED_IN_LOCALSTORAGE } from 'features/login/constants';
import { SITE_URL } from 'constants/api';
import SEO from 'global/SEO';

interface GroupInvitationPageProps {
  isLoggedIn: boolean;
  groupInvitationData: any;
  groupInvitationCode: string;
}

function GroupInvitationPage({
  isLoggedIn: isLoggedInCookies,
  groupInvitationData,
  groupInvitationCode,
}: GroupInvitationPageProps) {
  // wait until component did mount to get ls object
  const { value } = useLocalStorage(IS_LOGGED_IN_LOCALSTORAGE);
  const isLoggedIn = value || isLoggedInCookies;

  let propsSEO = {};

  // SEO for response API group shared link invitation
  if (groupInvitationData) {
    const {
      info: { description, avatar_url: avatarUrl, name },
    } = groupInvitationData;
    const showedName = sanitizer.sanitize.keepSpace(name);

    propsSEO = {
      title: showedName || GROUP_SHARED_LINK_INVITATION.METATAG.DEFAULT_NAME,
      description: description.substr(
        0,
        GROUP_SHARED_LINK_INVITATION.MAX_WORDS_DESCRIPTION,
      ),
      url: `${SITE_URL}/chat/group/invitation/${groupInvitationCode}`,
      image: avatarUrl || GROUP_SHARED_LINK_INVITATION.METATAG.DEFAULT_IMAGE,
    };
  }

  // will check isLoggedIn from localStorage
  return (
    <>
      <SEO {...propsSEO} />
      {isLoggedIn ? (
        <GroupInvitation code={groupInvitationCode} />
      ) : (
        <GuestInvitation data={groupInvitationData} />
      )}
    </>
  );
}

export async function getServerSideProps(context) {
  const { params } = context;
  let { code } = params;
  code = sanitizer.sanitize(code);

  const isLoggedIn = Boolean(authCookie.getIsLoggedIn(context));

  let groupInvitationData = {
    isDataFound: false,
    info: {
      name: GROUP_SHARED_LINK_INVITATION.METATAG.DEFAULT_NAME,
      shortened_name: '',
      description: '',
      avatar_url: GROUP_SHARED_LINK_INVITATION.METATAG.DEFAULT_IMAGE,
    },
  };
  if (code && !isLoggedIn) {
    try {
      const request = await chatApi.getGroupInvitationGuestPreview(code);

      if (request.data && request.status === 200) {
        groupInvitationData = request.data.data;
        groupInvitationData.isDataFound = true;
      }
    } catch (err) {
      // group avatar will be NoGroupAvatar in GroupAvatar
      groupInvitationData.info.avatar_url = '';
    }
  }

  return {
    props: {
      isLoggedIn,
      groupInvitationData,
      groupInvitationCode: code,
    },
  };
}

export default GroupInvitationPage;
